// Test ids for the navigation surfaces (main sidebar, account menu, Settings
// panel). They are derived from the same config that renders the UI, so a new
// nav item / menu entry / settings tab gets a stable hook for free instead of a
// follow-up PR every time QA needs one.
//
// Convention: `<surface>-<element>-<key>`, where the key is slugified from what
// the user actually sees (or from the config id where one already exists, e.g.
// settings tabs use the same id as the URL hash).
//
//   sidebar-group-deflect
//   sidebar-item-receipts        sidebar-item-receipts-configure
//   user-menu-item-logout        user-menu-theme-option-dark
//   settings-tab-my_profile      settings-section-personal

export const slugifyTestId = (value) =>
  String(value ?? "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")

// Joins the prefix with every non-empty part, e.g.
// buildTestId("sidebar-item", "receipts", "Configure") -> "sidebar-item-receipts-configure".
// Returns undefined when there is no key at all, so React drops the attribute
// instead of rendering `data-testid="sidebar-item-"`.
export const buildTestId = (prefix, ...parts) => {
  const key = parts.map(slugifyTestId).filter(Boolean).join("-")
  return key ? `${prefix}-${key}` : undefined
}
